import React from 'react';
import * as Yup from "yup"
import { Formik, useFormik } from 'formik';
import styled from './ChangePassword.module.css';
import Button from '../../components/common/button/Button';
import TextInput from '../../components/common/input/TextInput';
import { useNavigate } from 'react-router-dom';
import callApi from '../../services/api/apiClient';
import { state } from '../../redux/util/getStore';
import { AccessTokenSlice } from '../../redux/reducers/reducer';
import { requestProductSlice } from '../../helper/customSlice';
import { dispatchStore } from '../../lib/dispatchStore';
import { useToast } from '../../components/toast/Toast';

const changePasswordSchema = Yup.object().shape({
    old_password: Yup.string()
        .min(3, "Password must be at least 3 characters long")
        .required("Password is required"),
    new_password: Yup.string()
        .min(3, "Password must be at least 3 characters long")
        .required("Password is required"),
    confirm_password: Yup.string()
        .min(3, "Password must be at least 3 characters long")
        .required("Password is required"),
});


const ChangePassword = () => {

    const navigate = useNavigate()
    const { showToast } = useToast()

    const handleLogout = () => {
        const access_token = state("AccessToken");

        callApi('auth/logout')
            .withHeaders({
                'access-token': access_token,
            })
            .loadingGroup('logout')
            .execute()
            .then(res => {
                if (res.status === 'success') {
                    dispatchStore(AccessTokenSlice.actions.setAccessToken(null));
                    dispatchStore(requestProductSlice.actions.resetSelectProduct())
                }
            });
    }

    const formik = useFormik({
        initialValues: {
            old_password: "",
            new_password: "",
            confirm_password: "",
        },
        validationSchema: changePasswordSchema,
        onSubmit: (values, actions) => {
            if (values?.new_password === values.new_password) {
                callApi('auth/changePassword')
                    .withBody({
                        old_password: values?.old_password,
                        new_password: values?.new_password,
                    })
                    .loadingGroup('changePassword')
                    .execute()
                    .then(res => {
                        console.log("Res....", res)
                        if (res.status === 'success') {
                            handleLogout()
                            navigate('/login')
                            showToast('Password is changed successfully!', 'success')

                        } else {
                            console.log("Error", res?.error)
                            showToast(res?.message ? res?.message : res?.error, 'error')
                        }
                    })
                    .catch(error => {
                        console.log('Error....', error);
                        showToast(error, 'error')
                    });
            } else {
                console.log("Please enter the same password")
            }
        }
    })

    return (
        <div className={styled.main_container}>
            <div className={styled.change_password}>
                <p className={styled.title}>Change Password</p>
                <form action="" onSubmit={formik.handleSubmit}>
                    <div className="mt-[24px]">
                        <TextInput
                            name={"old_password"}
                            type="password"
                            label={"Old Password"}
                            placeholder={"Enter old password"}
                            className={"w-full"}
                            onChange={formik.handleChange}
                            value={formik.values.old_password}
                            required
                        />
                    </div>
                    <div className="mt-[24px]">
                        <TextInput
                            name={"new_password"}
                            type="password"
                            label={"New Password"}
                            placeholder={"Enter new password"}
                            className={"w-full"}
                            onChange={formik.handleChange}
                            value={formik.values.new_password}
                            required
                        />
                    </div>
                    <div className="mt-[24px]">
                        <TextInput
                            name={"confirm_password"}
                            type="password"
                            label={"Confirm New Password"}
                            placeholder={"Enter confirm password"}
                            className={"w-full"}
                            onChange={formik.handleChange}
                            value={formik.values.confirm_password}
                            required
                        />
                    </div>
                    <Button className={styled.button}>
                        Update
                    </Button>
                </form>
            </div>
        </div>
    )
}
export default ChangePassword;